export default {
  jobListingNotifications: [],
  jobListingNotification: undefined,
};
